export const iconFontAwesomeChildhoodChildDress = (
	<i className="fa-solid fa-child-dress"></i>
);
